import { useEffect, useContext } from 'react';
import SearchContext from '^/SearchContext';

const ProductOptionListItem = (props) => {

  const {
    name
  } = props;
  const {
    handleSearchCustomOptionAPI,
    searchResults,
    search
  } = useContext(SearchContext);


  const refinedName = name === 'Vehicle' ? 'Shop By Vehicle' : name

  const parsedList = searchResults.product_options[name]?.map(each =>
    <li class="ss-list-option ng-scope">
      <a href={`/products?search_query=${search}&filter=${name}:${encodeURIComponent(each.description)}`} class="ss-list-link ng-binding" >{each.description}</a>
    </li>
  )

  useEffect(() => {
    handleSearchCustomOptionAPI(name);
  }, [])

  if (!parsedList.length)
    return <></>


  return (
    <div id="ss-ac-custom_warning_color" class="ss-ac-facet-container ng-scope ss-ac-facet-container-list" >
      <h4 class="search-bar-results-title ng-binding">{refinedName}</h4>

      <ul class="ss-list ng-scope">
        {parsedList}
      </ul>
    </div>
  );
}
export default ProductOptionListItem;